/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { assetImages } from "constants";

const BlogSuccessMessageModal = ({
  afterBlogSaveClose = () => {},
  isUpdate = false,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className="modal fade"
      id="afterSaveBlogModal"
      tabIndex="-1"
      aria-labelledby="saveInfoLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 rounded-4 shadow-lg">
          {/* Header with primary color */}
          <div className="modal-header bg-primary text-white border-0 rounded-top-4 py-3">
            <h5 className="modal-title w-100 text-center fw-bold">
              <span className="material-symbols-outlined align-middle me-2">
                check_circle
              </span>
              {t("Success")}
            </h5>
          </div>

          {/* Body */}
          <div className="modal-body text-center px-4 py-5">
            <div className="mb-4">
              <div className="bg-primary bg-opacity-10 rounded-circle d-inline-flex p-4 mb-3">
                <span
                  className="material-symbols-outlined text-primary"
                  style={{ fontSize: "48px" }}
                >
                  task_alt
                </span>
              </div>
              <h4 className="fw-bold mb-2">
                {isUpdate
                  ? t("Blog Updated Successfully!")
                  : t("Blog Created Successfully!")}
              </h4>
              <p className="text-muted mb-0">
                {isUpdate
                  ? t("Your blog has been updated and saved.")
                  : t("Your blog has been created and saved.")}
              </p>
            </div>

            <div className="border-top pt-4 mt-4">
              <p className="fw-semibold mb-3">
                {t("What would you like to do next?")}
              </p>
              <div className="d-grid gap-3">
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-primary btn-lg d-flex align-items-center justify-content-center gap-2"
                  onClick={() => afterBlogSaveClose("edit")}
                >
                  <span className="material-symbols-outlined">edit</span>
                  {isUpdate ? t("Continue Editing") : t("Edit Blog")}
                </button>

                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-outline-primary btn-lg d-flex align-items-center justify-content-center gap-2"
                  onClick={() => afterBlogSaveClose("list")}
                >
                  <span className="material-symbols-outlined">list</span>
                  {t("Go to Blog List")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogSuccessMessageModal;
